<div class="drop-down-container" appClickOutside (clickOutside)="closeDropdown()" [ngClass]="{'open': isOptionsVisible, 'close': !isOptionsVisible}">
  <div  class="drop-down-title">{{title?.text | translate }}</div>
  @if (selected) {
    <div  class="drop-down-selection" (click)="toggleOptionsVisibility()">
      <span class="selected-title">{{(selected[key] | translate) ?(selected[key] | translate):(selected.title?selected.title:selected | translate)}}</span>
      <span class="icon icon_down_arrow"></span>
    </div>
  }
  <div class="drop-down-option-container">
    @for (option of options; track option) {
      <div role="button" class="drop-down-option" (click)="selectOption(option)">
        {{ (option[key] | translate ) ? (option[key] | translate):option.title}}
      </div>
    }
  </div>
</div>
